import { stumble } from '@ipfabric/frontend-shared-assets/utils/stumble/stumble';
import type { Filters, TableColumnSort } from '@ipfabric/utils';
import type { DeviceViewEntityId } from 'components/DeviceView/deviceViewTypes';
import { getDeviceViewEntityTables } from '../../helpers/getDeviceViewEntityTables';
import type { DeviceViewCommandFactory } from '../DeviceViewModel';

export interface ShowTableCommand {
  deviceViewEntityId: DeviceViewEntityId;
  filter?: Filters;
  sort?: TableColumnSort;
  webEndpoint: string;
}

export const showTable: DeviceViewCommandFactory<ShowTableCommand> =
  (cmdContext) => (command) => {
    // biome-ignore lint/complexity/noExcessiveCognitiveComplexity: TBD eventually cleanup
    cmdContext.updateState((draft) => {
      const deviceViewEntity = draft.deviceViewEntities.find(
        (entity) => entity.id === command.deviceViewEntityId,
      );
      if (
        deviceViewEntity !== undefined &&
        (deviceViewEntity.deviceViewElement === 'node' ||
          deviceViewEntity.deviceViewElement === 'edge')
      ) {
        const { pathsWithName } = cmdContext.getState();
        const deviceViewEntityTables = getDeviceViewEntityTables(
          deviceViewEntity,
          draft.settings,
          pathsWithName,
        );
        const deviceViewTable = deviceViewEntityTables.find(
          (table) => table.webEndpoint === command.webEndpoint,
        );
        if (
          deviceViewTable === undefined &&
          deviceViewEntity.deviceViewElement === 'node'
        ) {
          const name = pathsWithName[command.webEndpoint];
          if (name === undefined) {
            stumble('Invalid web endpoint to open table');
            return;
          }
          if (!deviceViewEntity.nodeType) {
            return;
          }
          const { nodeType } = deviceViewEntity;
          if (!nodeType) {
            return;
          }
          const elementSettings =
            draft.settings.nodes[nodeType] ?? draft.settings.nodes._any;
          if (elementSettings === undefined) {
            return;
          }
          elementSettings.unshift({
            label: name,
            webEndpoint: command.webEndpoint,
          });
        }
        deviceViewEntity.table = command.webEndpoint;
        if (command.filter !== undefined) {
          deviceViewEntity.tableFilters[command.webEndpoint] = command.filter;
        }
        if (command.sort !== undefined) {
          deviceViewEntity.tableSort[command.webEndpoint] = command.sort;
        }
        if (deviceViewEntity.redirectToTable !== undefined) {
          deviceViewEntity.redirectToTable = undefined;
        }
      } else {
        stumble('Unknown device explorer entity when opening table');
      }
    });
  };
